import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [],
    exports: [
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule
    ],
    declarations: []
})
export class RestaurantsMaterialModule { }
